<template>
  <div>
    <!-- 顶部导航 -->
    <van-nav-bar
      :left-arrow="showLeftArrow"
      :title="activeTitle"
      :right-text="canCancelOrder ? '取消' : ''"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      fixed
      placeholder
    />
    <div class="router-view">
      <transition
        name="fade-transform"
        mode="out-in"
      >
        <router-view />
      </transition>
    </div>
    <OrderReport
      :task-detail="taskDetail"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ORDER_STATUS_CODE, TASK_STATUS_CODE } from '@/common/constant';
import savePositionMixin from './mixins/savePositionMixin';
import OrderReport from '@/components/orderReport.vue';
export default {
  mixins: [savePositionMixin],
  components: {
    OrderReport
  },
  data() {
    return {
      orderNo: '',
      taskNo: '',
      orderDetail: null
    };
  },
  computed: {
    ...mapState('orderGeneral', ['taskDetail']),
    canCancelOrder() {
      return [
        'GeneralOrderWaitService',
        'GeneralOrderWaitArrive',
        'GeneralOrderTrailing'
      ].includes(this.$route.name) ||
        ([
          'GeneralOrderAccidentRescue'
        ].includes(this.$route.name) &&
        ![ORDER_STATUS_CODE.auditReturn, ORDER_STATUS_CODE.settlementReturn].includes(this.taskDetail.orderStatus));
    },
    activeTitle() {
      let activeTitle = this.$route.meta.title;
      if ([
        'GeneralOrderAccidentRescue'
      ].includes(this.$route.name)) {
        if ([ORDER_STATUS_CODE.auditReturn, ORDER_STATUS_CODE.settlementReturn].includes(this.taskDetail.orderStatus)) {
          activeTitle = '审核退回';
        } else if ([TASK_STATUS_CODE.workStart].includes(this.taskDetail.taskStatus) || [TASK_STATUS_CODE.workEnd].includes(this.taskDetail.taskStatus)) {
          activeTitle = '服务中';
        }
      }
      return activeTitle;
    },
    showLeftArrow() {
      const name = this.$route.name;
      return ['GeneralOrderCertificate'].includes(name);
    }
  },
  created() {
    const {
      orderNo,
      taskNo
    } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
  },
  mounted() {
  },
  methods: {
    toPage(name) {
      const router = {
        name,
        params: {
          fromPage: this.$route.name,
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      };
      this.$router.push(router);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.toPage('GeneralOrderCancelOrder');
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
